<template lang='pug'>
  div(:class='[$style[`cc-checkbox`], $style[errorValue ? `has-error` : ``]]')
    label(:class='$style[`cc-checkbox-label`]')
      input(
        type='checkbox'
        :checked='checkStatus'
        @click='setCheckBoxStatus(isCheckBoxActive = !isCheckBoxActive)'
      )
      span(
        role='button'
        tabindex='0'
        aria-label='勾選同意'
        :class='$style[`cc-checkmark`]')
    span(
      v-html='labeltxt'
      :class='$style[`cc-checkbox-text`]')

</template>

<script>
export default {
  components: {},

  props: {
    labelText: {
      type: String,
      default: '',
    },
    defaultChecked: {
      type: Boolean,
      default: false,
    },
    errorValue: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      labeltxt: this.labelText,
      isCheckBoxActive: this.defaultChecked,
      checkStatus: this.defaultChecked ? 'checked' : '',
    };
  },

  methods: {
    setCheckBoxStatus(status) {
      status ? this.checkStatus = 'checked' : this.checkStatus = '';
      this.$emit('sendCheckStatus', this.checkStatus, this.labeltxt);
      this.$emit('clearErrorMsg', false);
    },
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/common/checkbox.scss';
</style>
